// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TWebChatsGetRequest, TWebChatsGetModel, IMappers, TWebChatsGetResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISyncAppsResponseSchema } from '../../../../entities/synchronization/SyncAppsResponseSchema';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createWebChatsGetModel(parameters: TWebChatsGetRequest): TWebChatsGetModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v2/web/chats/get/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebChatsGetOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebChatsGetRequest;
}

export async function fetchWebChatsGet<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebChatsGetOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebChatsGetResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebChatsGetModel(parameters),
    config,
  )) as FetchResponse<TWebChatsGetResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISyncAppsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebChatsGetResponse>;
}
